module.exports = __webpack_public_path__ + "static/media/content-ad-based-icon.437489f2.svg";